var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "next"
    ? _c(
        "button",
        {
          staticClass:
            "inline-flex between-xs w-100 px25 py20 pr15 serif cl-accent",
          attrs: {
            type: "button",
            "aria-label": _vm.$t("Show subcategories"),
            "data-testid": "categoryButton"
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.next()
            }
          }
        },
        [
          _vm._v("\n  " + _vm._s(_vm.name) + "\n  "),
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("keyboard_arrow_right")
          ])
        ]
      )
    : _c(
        "button",
        {
          staticClass: "inline-flex p15 between-xs",
          attrs: { type: "button", "aria-label": _vm.$t("Back") },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.back()
            }
          }
        },
        [
          _vm._v("\n  " + _vm._s(_vm.name) + "\n  "),
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("keyboard_arrow_left")
          ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }